package com.mgacreative.hotel.feature.finance.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.core.tenant.TenantSession
import com.mgacreative.hotel.domain.model.CashMovement
import com.mgacreative.hotel.domain.repository.CurrentAccount
import com.mgacreative.hotel.domain.repository.FinanceRepository
import com.mgacreative.hotel.feature.finance.domain.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class FinanceViewModel(
    private val financeRepository: FinanceRepository,
    private val tenantSession: TenantSession,
    private val eInvoiceProvider: EInvoiceProvider? = null
) : ViewModel() {

    private val _accessError = MutableStateFlow<String?>(null)
    val accessError: StateFlow<String?> = _accessError.asStateFlow()

    val movements: StateFlow<List<CashMovement>> = financeRepository.observeCashMovements()
        .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), emptyList())

    val accounts: StateFlow<List<CurrentAccount>> = financeRepository.observeCurrentAccounts()
        .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), emptyList())

    val cashBalance: Double get() {
        var balance = 0.0
        movements.value.forEach { 
            if (it.type == "INCOME") balance += it.amount 
            else if (it.type == "EXPENSE") balance -= it.amount 
        }
        return balance
    }

    private val _invoiceFolioItems = MutableStateFlow<List<FolioItem>>(emptyList())
    val invoiceFolioItems: StateFlow<List<FolioItem>> = _invoiceFolioItems.asStateFlow()

    init {
        checkAccessAndLoadData()
    }

    private fun checkAccessAndLoadData() {
        val currentRole = tenantSession.currentRole
        if (currentRole != com.mgacreative.hotel.core.tenant.UserRole.HOTEL_OWNER && currentRole != com.mgacreative.hotel.core.tenant.UserRole.ACCOUNTING && currentRole != com.mgacreative.hotel.core.tenant.UserRole.SUPER_ADMIN) {
            _accessError.value = "Yetki Hatası: Bu sayfaya yalnızca Otel Sahibi ve Muhasebe rolleri erişebilir."
            return
        }

        viewModelScope.launch {
            financeRepository.loadCashMovements()
            financeRepository.loadCurrentAccounts()
        }
    }

    fun addMovement(type: String, amount: Double, desc: String, date: String) {
        viewModelScope.launch {
            financeRepository.addCashMovement(type, amount, desc, date)
        }
    }

    fun addCurrentAccount(name: String, type: String, balance: Double) {
        viewModelScope.launch {
            financeRepository.addCurrentAccount(name, type, balance)
        }
    }

    fun loadFolioForInvoice(reservationId: String) {
        viewModelScope.launch {
            // Mock folio fetch from reservations/payments tables
            _invoiceFolioItems.value = listOf(
                FolioItem("Konaklama (3 Gece)", 450.0),
                FolioItem("Mini Bar", 25.0),
                FolioItem("Çamaşırhane", 15.0)
            )
        }
    }

    fun issueEInvoice(customerName: String) {
        viewModelScope.launch {
            val total = _invoiceFolioItems.value.sumOf { it.price }
            val data = InvoiceData(
                id = "inv_${kotlin.random.Random.nextInt()}",
                customerName = customerName,
                items = _invoiceFolioItems.value,
                totalAmount = total,
                taxAmount = 0.0
            )
            
            eInvoiceProvider?.createEInvoice(data)
        }
    }
}
